import React, { Component } from 'react';
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import { GridRow, SlimSection, withColor, SecondaryButton, Text, Link, Heading4, Heading2, BiggerText } from './MarketingStyles';
import { withRouter } from 'react-router-dom'
import config from 'react-global-configuration';

import { inject, observer } from 'mobx-react'

@inject('utilStore', 'translationStore')
@observer
class FeatureSection extends Component {

  constructor(props) {
    super(props)
    this.state = {
      selected: undefined,
    }
  }

  render() {

    const { qanda } = this.props.utilStore

    console.log(qanda)
    
    const text = (key) => {
      return this.props.translationStore.getText(key)
    }

    return (
      <SlimSection id="faq">
        <GridRow
          desktop="1fr 1fr"
          tablet="1fr"
        >
          <div>
            <Heading2>{ text('marketing_faq_headline') }</Heading2>
            <BiggerText>{ text('marketing_faq_text') }</BiggerText>
          </div>
        </GridRow>
        <QandAList>
          {
            qanda && qanda.map( item => {
              
              const selected = this.state.selected === item.id

              return (
                <QandAItem>
                  <QandAQuestion selected={ selected } onClick={ () => this.setState({ selected: selected ? undefined : item.id })}>{ item.question }</QandAQuestion>
                  <QandAAnswer selected={ selected }>
                    <div dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                  </QandAAnswer>
                </QandAItem>
              )
            })
          }
        </QandAList>
      </SlimSection>
    )
  }
}

export default FeatureSection

const QandAList = styled.div `
  width: 100%;
`
const QandAItem = styled.div `
  width: 100%;
  :not(:last-child) {
    border-bottom: 1px solid ${ cssVar.colors.blue };
  }
`
const QandAQuestion = styled(Heading4) `
  padding: 20px 40px;
  position: relative;
  cursor: pointer;

  :before {
    content: '▼';
    font-size: 12px;
    height: 12px;
    width: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0px;
    margin-top: 6px;
    transition: ${ cssVar.transitions.basic };

    transform: ${ props => props.selected ? '' : 'rotate(-90deg)' };
    transform-origin: center center;
  }
`

const GreyText = withColor(Text, cssVar.colors.grey)
const QandAAnswer = styled(GreyText) `
  padding: 0 40px 20px 40px;
  max-height: ${ props => props.selected ? '10000vh' : '0'  };
  padding: ${ props => props.selected ? '0 40px 20px 40px' : '0 40px 0 40px'  };
  opacity: ${ props => props.selected ? '1' : '0'  };
  letter-spacing: -0.03em;
  overflow: hidden;
  transition: ${ cssVar.transitions.basic };

  p {
    color: #2F4361;
  }
`



// WEBPACK FOOTER //
// /src/components/marketing/QandASection.js